import * as React from 'react';
import cn from 'clsx';
import { ArticleHeading2, Image } from '@cian/ui-kit';
import { ComponentWithInnerHTML } from '@cian/frontend-e2e-deal-component';

import { IDealFeatureCardModalDetails } from '../../../../types/promoInfo';
import { IWithDeviceTypeProps, withDeviceType } from '../../../../utils/withDeviceType';
import { DealSalePromoChip } from '../../../../components/DealSalePromoChip';
import { ListWithIcons } from '../../../../components/ListWithIcons';

import * as styles from './styles.css';

interface IDealFeaturesModalHeaderProps extends IDealFeatureCardModalDetails, IWithDeviceTypeProps {}

const DealFeaturesModalInfoCard: React.FC<React.PropsWithChildren<IDealFeaturesModalHeaderProps>> = ({
  title,
  badge,
  image,
  details,
  deviceType,
}) => {
  return (
    <section className={cn(styles['container'], styles[deviceType])}>
      <div className={styles['image']}>
        <Image
          width={148}
          height={120}
          objectFit="contain"
          srcSet={`${image.x2} x2, ${image.x1} x1`}
          src={image.x2}
          loading="lazy"
        />
      </div>
      <div className={styles['text-content-container']}>
        <DealSalePromoChip>{badge}</DealSalePromoChip>
        <ArticleHeading2 as="h3">{title}</ArticleHeading2>
        <ListWithIcons.List>
          {details.map((detail, i) => (
            <ListWithIcons.Item key={i}>
              <ComponentWithInnerHTML
                className={styles['detail-text']}
                html={detail}
                setHtmlOptions={{
                  whiteList: {
                    a: ['href', 'role', 'data-modal-link', 'target', 'rel'],
                    br: [],
                    span: [],
                    div: [],
                  },
                }}
              />
            </ListWithIcons.Item>
          ))}
        </ListWithIcons.List>
      </div>
    </section>
  );
};

const DealFeaturesModalInfoCardWithDeviceType = withDeviceType(DealFeaturesModalInfoCard);
export { DealFeaturesModalInfoCardWithDeviceType as DealFeaturesModalInfoCard };
